import { Box, Container, VStack} from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import { Info } from '../components/Info';
import { DEMANDA_COLECTIVA_IFE} from '../Constantes';

import DemandaColectivaIFEComponente from '../components/DemandaColectivaIFEComponente';




export const DemandaColectivaIFE: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={DEMANDA_COLECTIVA_IFE} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Formulario de reclamo de  débitos sobre acreditaciones IFE'} ></Title>
                                <Info infoList={[]} info={'Les recordamos que el período comprendido es año 2020 y que solo se deberá solicitar la devolución, en caso de no haber recibido reintegro oportunamente.'}></Info>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <DemandaColectivaIFEComponente />
                        </Box>
                    </Box>
                    
                </VStack>

            </VStack>
        </Container>

    )

}



